import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Testo } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteTesto, useTesto, useUpdateTesto } from '../../hooks/testi'
import TestoForm from '../../components/TestoForm'

export default function TestoEdit() {
  const { id } = useParams()
  const { data: testo } = useTesto(+id!)
  const deleteTesto = useDeleteTesto()
  const updateTesto = useUpdateTesto()
  const [modalRm, modalRmActions] = useModalTrigger<Testo>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/testi">Testi</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {testo!.titolo}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(testo)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <TestoForm
          testo={testo}
          save={(testo) =>
            updateTesto.mutateAsync(testo).then(() =>
              toast.success('Testo salvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il testo {modalRm.value.titolo}?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteTesto.isLoading}
            onClick={async () => {
              await deleteTesto.mutateAsync(modalRm.value!.id)
              navigate('/testi')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
